import { Chip, type SxProps, type Theme } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { spaces } from '../../../../assets/styles/themes/tokens';

const STATUS_CONFIG = {
	new: { label: 'New', color: 'success' },
	beta: { label: 'Beta', color: 'primary' },
} as const;

const FeatureStatusChip: React.FC<{
	size: 'medium' | 'small';
	sx?: SxProps<Theme>;
	status?: 'new' | 'beta';
}> = ({ size, sx, status = 'new' }) => {
	const { t } = useTranslation();
	const { label, color } = STATUS_CONFIG[status];

	return (
		<Chip
			data-testid="feature-status-chip"
			label={t(label)}
			color={color}
			size={size}
			sx={{
				position: 'absolute',
				top: spaces.sm,
				left: `-${spaces.sm}`,
				zIndex: 1, // To make sure it's on top of cover image in mobile view.
				...sx,
			}}
		/>
	);
};

export default FeatureStatusChip;
